import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Form, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { Utils } from 'src/app/common/utils';
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
import { sortBy } from 'underscore';
import { DoctorCalendarComponent } from '../doctor-calendar/doctor-calendar.component';
import { exit } from 'process';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-aptreq-dash',
  templateUrl: './aptreq-dash.component.html',
  styleUrls: ['./aptreq-dash.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AptreqDashComponent implements OnInit {

  @ViewChild('editRequestModal', { static: true } as any) editRequestModal: TemplateRef<any>;
  @ViewChild('checkRequestModal', { static: true } as any) checkRequestModal: TemplateRef<any>;
  @ViewChild('closeRequestModal', { static: true } as any) closeRequestModal: TemplateRef<any>;
  Appointmentss: any;
  apptlen: any;
  phyfname: string;
  aptime: any;


  constructor(private modal: NgbModal, private service: VproService, private spinner: NgxSpinnerService, private _formBuilder: UntypedFormBuilder, private _utils: Utils) { }

  Appointments1: [];
  editAppoint: any;
  AppointmentStatus = Utils.APPOINTMENT_STATUS;
  noAppointments: boolean = false;
  findAppointmentForm: UntypedFormGroup;
  editAptForm: UntypedFormGroup;
  currentDate = Utils.maxDate;
  //Pagination Parameters
  page: number = 1;
  pagesize: number = Utils.DEFAULT_PAGE_COUNT_SHOW;
  pageCount: number[] = Utils.PAGE_COUNT;
  collectionSize: number;
  AppointmentRequestType = Utils.APPOINTMENT_REQUEST_TYPE;
  isFilterActive: boolean;
  activeFilter: string;
  public fromDate: string;
  public toDate: string;
  public invalidForm: boolean
  dateFormat = Utils.DATE_FORMAT; // default date format from constants
  defaultdr = Utils.DEFAULTDR;
  public minDate: string;
  formSub: Subscription;
  formsub: Subscription;
  org_code: any;
  doc_name: any;
  dr_id: any

  typ: any = '';
  p: number = 1;



  ngOnInit() {

    this.loadPhysician();

    this.org_code = localStorage.getItem('orgcode');
    this.dr_id = localStorage.getItem('uid');

    this.findAppointmentForm = this._formBuilder.group({
      physicianName: [''],
      fromDate: ["", [Validators.required]],
      toDate: ["", [Validators.required]]
    });
    this.formSub = this.findAppointmentForm.valueChanges.subscribe(value => {
      if ((value.fromDate && !value.toDate) || (!value.fromDate && value.toDate)) {
        this.invalidForm = true;
      }
      if (value.fromDate && value.toDate) {
        this.invalidForm = false;
      }
      if (value.physicianName && !value.fromDate && !value.toDate) {
        this.invalidForm = false
      }
      if (!value.physicianName && !value.fromDate && !value.toDate) {
        this.invalidForm = false
      }
    })
    this.editAptForm = this._formBuilder.group({
      apDate: [null],
      apTime: ['']
    })
    this.formsub = this.findAppointmentForm.get('fromDate').valueChanges.subscribe((value) => {
      if (value) {
        this.minDate = value;
        this.findAppointmentForm.get("toDate").setValue("");
        this.findAppointmentForm.get("toDate").updateValueAndValidity();
      }
    })

  }



  loadPhysician() {
    this.service.getPhysicianById(localStorage.getItem("uid"), '?fields=physician_dashboard').subscribe(
      (response) => {
        console.log("responseresponseresponse", response)
        this.phyfname = response.first_name;
        console.log("dashboarddatadashboarddata", this.phyfname);

        this.findAppointments(this.typ, this.p);
      })
  }

  editRequest(appointment): void {
    this.editAppoint = { ...appointment }

    this.editAptForm.reset();
    let startDate = this.editAppoint.apdate.split('-');
    let startTime = this.editAppoint.aptime.split(':');
    startDate = { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }

    this.editAptForm.patchValue({
      apDate: startDate,
      apTime: { hour: parseInt(startTime[0]), minute: parseInt(startTime[1]) }
    })

    let { year, month, day } = startDate
    this.editAppoint.apdate = `${year}-${month}-${day}`;
    this.aptime = this.transform(this.editAppoint.aptime)
    this.modal.open(this.editRequestModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  checkRequest(appointment): void {
    this.editAppoint = { ...appointment };
    this.modal.open(this.checkRequestModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  closeRequest(appointment): void {
    this.editAppoint = { ...appointment };
    this.modal.open(this.closeRequestModal, { size: 'lg', centered: true, backdrop: 'static' });
  }

  findAppointments(type = '', pg: number = 1) {


    this.Appointments1 = [];

    let datas = {
      org_code: this.org_code,
      //doc_name: this.phyfname,
      //doc_name: localStorage.getItem("first_name"),
      //drid: this.dr_id,
      drid: JSON.parse(localStorage.getItem('uid')),
      status: [this.AppointmentStatus.APPROVAL_REQUESTED],
      // from: moment().format("YYYY-M-DD"),
      // to: moment().format("YYYY-M-DD"),
    }


    console.log("datasdatasdatas", datas);


    this.service.displayAppoint(datas, `page=${this.page}&limit=${this.pagesize}`).subscribe(res => {
      this.spinner.hide();
      this.Appointments1 = res['data'];
      this.apptlen = this.Appointments1.length;

      console.log("APPOINTTAPPOINTT", this.apptlen);

      // Sample JSON data
      let dridd = JSON.parse(localStorage.getItem("uid"));
      //console.log("DRIDDRIDDRID", dridd);

      this.collectionSize = res['totalCount'];
      if (this.Appointments1 && this.Appointments1.length) {
        // this.Appointments = sortBy(this.Appointments, 'aptime'); // Data Sorter via underscore.js
        // this.Appointments = sortBy(this.Appointments, 'apdate'); // Data Sorter via underscore.js
        this.noAppointments = false;
      }
      else {
        this.noAppointments = true;
        this.page = 1;
        this.pagesize = Utils.DEFAULT_PAGE_COUNT_SHOW;
      }
    }, err => {
      this.spinner.hide();
      console.log(err);
    })


  }

  editAppointment(action) {
    this.modal.dismissAll();
    console.log("action,", action)
    if (action === 'edit') {
      this.editAppoint.status = this.editAppoint.request_type === Utils.APPOINTMENT_REQUEST_TYPE.CANCELLED ?
        this.AppointmentStatus.CANCELLED : this.AppointmentStatus.SCHEDULED;
      delete this.editAppoint.endtime;
    }

    if (action === 'approve') {
      this.editAppoint.status = this.editAppoint.request_type === Utils.APPOINTMENT_REQUEST_TYPE.CANCELLED ?
        this.AppointmentStatus.CANCELLED : this.AppointmentStatus.SCHEDULED;
      let aptDate = this.editAppoint.apdate.split('-');
      aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }
      let { year, month, day } = aptDate
      this.editAppoint.apdate = `${year}-${month}-${day}`;
    }

    if (action === 'cancel') {
      this.editAppoint.status = this.AppointmentStatus.REJECTED;
      let aptDate = this.editAppoint.apdate.split('-');
      aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }
      let { year, month, day } = aptDate
      this.editAppoint.apdate = `${year}-${month}-${day}`;
    }
    this.editAppoint.uid = this.editAppoint.u_id
    this.editAppoint.drid = this.editAppoint.uid
    delete this.editAppoint.u_id;

    this.spinner.show();
    this.service.editSchedule(this.editAppoint, this.editAppoint.aid).subscribe(res => {
      this.spinner.hide();
      this.showToast('success', res);
      this.findAppointments();
    }, err => {
      this.spinner.hide();
      console.log(err);
      let message = "Something wrong. Couldn't complete request.";
      if (err && err.error && err.error.error) {
        this.showToast('error', err.error.error);
        return;
      }
      this.showToast('error', message);
    })
  }

  dateTimeChangeEvent() {
    if (this.editAptForm.value.apDate) {
      let { year, month, day } = this.editAptForm.value.apDate
      this.editAppoint.apdate = `${year}-${month}-${day}`;
    }
    if (this.editAptForm.value.apTime) {
      let { hour, minute } = this.editAptForm.value.apTime
      this.editAppoint.aptime = `${hour}:${minute}`;
      this.aptime = this.transform(this.editAppoint.aptime);
      let aptDate = this.editAppoint.apdate.split('-');
      aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }

      // Validate Start Time
      let startDate = this.editAptForm.value.apDate || aptDate;
      let startTime = this.editAptForm.value.apTime;

      let isInvalid = Utils.validateStartTime(startTime, startDate);
      if (isInvalid) {
        this.editAptForm.controls['apTime'].setErrors({ 'invalidStartTime': isInvalid })
      }
      else {
        this.editAptForm.controls['apTime'].setErrors(null)
      }
    }
  }

  public checkIfDoctor() {
    let userRoles = JSON.parse(localStorage.getItem("LogUsrTyp"));
    if (userRoles) return this._utils.checkRoleType(Utils.USER_TYPE.physician, userRoles) && !this._utils.checkRoleType(Utils.USER_TYPE.admin, userRoles)
    return false;
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }


  openCalendarMOdal() {
    const modalRef = this.modal.open(DoctorCalendarComponent, { backdropClass: 'modal-backdrop', size: 'lg', centered: true, backdrop: 'static' });

    modalRef.componentInstance.drid = this.editAppoint.u_id;

    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.patchDateAndTime(receivedEntry);
      modalRef.close();
    })

    modalRef.componentInstance.closeModal.subscribe((val) => {
      modalRef.dismiss();
    })

    modalRef.result.then(
      (result) => {
        console.log("result", result);
      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  patchDateAndTime(dateTime) {
    this.editAptForm.patchValue({
      apDate: { year: parseInt(moment(dateTime).format('YYYY')), month: parseInt(moment(dateTime).format('MM')), day: parseInt(moment(dateTime).format('DD')) },
      apTime: { hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) }
    })
    this.dateTimeChangeEvent();
  }
  // On page change call the findAppointments function with params activeFilter and page
  pageChanged() {
    this.findAppointments(this.activeFilter, this.page);
  }

  ngOnDestroy() {
    if (this.formSub) {
      this.formSub.unsubscribe();
    }
    if (this.formsub) {
      this.formsub.unsubscribe()
    }


  }

  transform(time: any): any {
    let hour = (time.split(':'))[0]
    let min = (time.split(':'))[1]
    let part = hour > 12 ? 'pm' : 'am';
    if (parseInt(hour) == 0)
      hour = 12;
    min = (min + '').length == 1 ? `0${min}` : min;
    hour = hour > 12 ? hour - 12 : hour;
    hour = (hour + '').length == 1 ? `0${hour}` : hour;
    return `${hour}:${min} ${part}`
  }

}